export function resolveActiveTenantId(
  claims: Record<string, unknown>,
  tenantIds: string[],
): string | null {
  // `tenant_id: null` è un fail-closed esplicito del server e non deve essere
  // sostituito dal primo tenant. Il fallback serve soltanto ai token legacy nei
  // quali il claim non esisteva affatto.
  if (Object.prototype.hasOwnProperty.call(claims, 'tenant_id')) {
    return typeof claims.tenant_id === 'string' && claims.tenant_id.length > 0
      ? claims.tenant_id
      : null;
  }
  return tenantIds[0] ?? null;
}
